import React from "react";
import { connect } from "react-redux";
import { compose } from 'redux';

import { get } from "lodash";
import 'react-select/dist/react-select.css';
import Select from "react-select";

import * as authSelectors from "../../redux/auth/selectors";
import * as projectSelectors from '../../redux/projects/selectors'
import * as checklistSelectors from '../../redux/checklists/selectors'

import Dialog from "material-ui/Dialog";
import FlatButton from "material-ui/FlatButton";

import { DEFAULT_SELECT_OPTION } from './ChecklistProjectSelect';

const mapStateToProps = state => ({
  userId: authSelectors.getUserId(state),
  projectsList: projectSelectors.projectsList(state),
  checklistProjectId: checklistSelectors.checklistProjectId(state)
});

class ShareChecklistDialog extends React.Component {
  state = {
    selectedProject: DEFAULT_SELECT_OPTION
  };

  handleChange = (value) => {
    this.setState({selectedProject: value})
  };

  get options() {
    const { projectsList, userId, checklistProjectId } = this.props;

    const options = [DEFAULT_SELECT_OPTION];

    Object.values(projectsList).forEach(project => {
      if (!project.id) {
        return;
      }

      let isProjectOwner = get(project, 'owner.id') === userId;

      if (!isProjectOwner) {
        const allowMembersToChangeChecklists = get(project, 'allowMembersToChangeChecklists');

        if (allowMembersToChangeChecklists) {
          isProjectOwner = true;
        }
      }

      if (!isProjectOwner) {
        return;
      }

      if (checklistProjectId === get(project, 'id')) {
        return;
      }

      const option = {
        key: project.id,
        label: project.title
      };

      options.push(option);
    });

    return options;
  };

  handleShare = () => {
    const { onShare, activeChecklist, onClose } = this.props;
    const { selectedProject } = this.state;

    onShare({checklist: activeChecklist, projectId: selectedProject.key});

    onClose();
  };

  render() {
    const { onClose, isOpen } = this.props;
    const { selectedProject } = this.state;

    // console.log(activeChecklist);
    return (
      <Dialog
        onClose={onClose}
        open={isOpen}
        className="shareDialog"
      >
        {/* <div style={{ maxHeight: 760, width: '100%', overflowY: 'auto' }}> */}
        <div style={{ textAlign: "center", color: 'black', fontWeight: 700, fontSize: 18 }}>Share checklist</div>

        <div style={{ marginTop: '15px' }} />
          <div style={{ textAlign: "center", fontWeight: 600, fontSize: 16 }}>You can use this checklist in other projects.</div>
          <div style={{ marginTop: '3px' }} />
          <div style={{ fontWeight: 600, fontSize: 14 }}>
            If you own the other project (you opened that project)  simply share it here with that project and all project members will be able to use it from the project checklist folder.You can also share it to your <u><b>private list</b></u> and then you can use it in all of your projects from your private checklist folder.
          </div>

          <div style={{ marginTop: '5px' }} />
          <Select
            clearable={false}
            autosize={false}
            onBlurResetsInput={false}
            // arrowRenderer={() => null}
            options={this.options}
            valueKey="label"
            placeholder="Select project"
            onChange={this.handleChange}
            value={selectedProject}
            // optionRenderer={this.renderCountryOption}
            // valueRenderer={this.renderCountryValue}
            matchProp="any"
            scrollMenuIntoView={false}
          />

          <div style={{ marginTop: '5px' }} />

          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <FlatButton label="Cancel" onClick={onClose} />
            <FlatButton label="Share" onClick={this.handleShare} disabled={false}/>
          </div>

        {/* </div> */}
      </Dialog>
    );
  }
}

const enchance = compose(
  connect(mapStateToProps),
);

export default enchance(ShareChecklistDialog);
